interface Chip {
  key: string;
  name: string;
}
interface ChipsMap {
  [key: string]: Chip;
}
export const chipsData: ChipsMap = {
  status: {
    key: 'stato',
    name: 'Status',
  },
  projectStatus: {
    key: 'projectStatus',
    name: 'Status',
  },
  stati: {
    key: 'stati',
    name: 'Status',
  },
  projectType: {
    key: 'projectType',
    name: 'Project Type',
  },
  projectName: {
    key: 'projectName',
    name: 'Project Name',
  },
  nomeProgetto: {
    key: 'nomeProgetto',
    name: 'Project Name',
  },
  nome: {
    key: 'nome',
    name: 'Project Name',
  },
  typology: {
    key: 'tipologia',
    name: 'Typology',
  },
  businessUnit: {
    key: 'businessUnit',
    name: 'Business Unit',
  },
  deliveryUnit: {
    key: 'deliveryUnit',
    name: 'Delivery Unit',
  },
  priceRange: {
    key: 'priceRange',
    name: 'Price Range',
  },
  dateRange: {
    key: 'dateRange',
    name: 'Date Range',
  },
  nomeCliente: {
    key: 'nomeCliente',
    name: 'Account Name',
  },
  idCliente: {
    key: 'idCliente',
    name: 'Account Name',
  },
  idProgetto: {
    key: 'idProgetto',
    name: 'Project ID',
  },
  projectId: {
    key: 'projectId',
    name: 'Project ID',
  },
  idProject: {
    key: 'idProject',
    name: 'Project ID',
  },
  id: {
    key: 'id',
    name: 'Project ID',
  },
  personaId: {
    key: 'personaId',
    name: 'Collaborator',
  },
  personaIdList: {
    key: 'personaIdList',
    name: 'Collaborators',
  },
  plUserId: {
    key: 'plUserId',
    name: 'PL',
  },
  plUserLv2Id: {
    key: 'plUserLv2Id',
    name: 'PL Lv 2',
  },
  businessManager: {
    key: 'businessManager',
    name: 'CL/AM',
  },
  projectManager: {
    key: 'projectManager',
    name: 'Project Manager',
  },
  projectManagerLv2: {
    key: 'projectManagerLv2',
    name: 'Project Manager Lv 2',
  },
  delegateUserId: {
    key: 'delegateUserId',
    name: 'Delegate User',
  },
  flagPlaceholderPlanned: {
    key: 'flagPlaceholderPlanned',
    name: 'Placeholder user',
  },
  mesiAnni: {
    key: 'mesiAnni',
    name: 'Period',
  },
  isUserActive: {
    key: 'isUserActive',
    name: 'Active resources',
  },
  quoteId: {
    key: 'quoteId',
    name: 'Quote ID',
  },
  opportunityId: {
    key: 'opportunityId',
    name: 'Opportunity ID',
  },
  signatureRange: {
    key: 'signatureRange',
    name: 'Signature Range',
  },
  orderId: {
    key: 'orderId',
    name: 'Order ID',
  },
  object: {
    key: 'object',
    name: 'Object',
  },
  automaticRenewal: {
    key: 'automaticRenewal',
    name: 'Automatic Renewal',
  },
  withoutExternalCosts: {
    key: 'withoutExternalCosts',
    name: 'Without External Costs',
  },
  legalEntities: {
    key: 'legalEntities',
    name: 'Legal Entities',
  },
  contractStatus: {
    key: 'contractStatus',
    name: 'Contract Status',
  },
  orderProcessingStatus: {
    key: 'orderProcessingStatus',
    name: 'Order Processing Status',
  },
  expenseItems: {
    key: 'expenseItems',
    name: 'Expense Items',
  },
  suppliers: {
    key: 'suppliers',
    name: 'Suppliers',
  },
  categories: {
    key: 'categories',
    name: 'Categories',
  },
  startEndRange: {
    key: 'startEndRange',
    name: 'Start/End Range',
  },
  ordNumero: {
    key: 'ordNumero',
    name: 'Order Number',
  },
  clienteId: {
    key: 'clienteId',
    name: 'Account',
  },
  aziendaId: {
    key: 'aziendaId',
    name: 'Legal Entity',
  },
  businessManagerId: {
    key: 'businessManagerId',
    name: 'CL/AM',
  },
  ordCig: {
    key: 'ordCig',
    name: 'CIG',
  },
  ordCup: {
    key: 'ordCup',
    name: 'CUP',
  },
  ordSdi: {
    key: 'ordSdi',
    name: 'SDI',
  },
  ordOggetto: {
    key: 'ordOggetto',
    name: 'Object',
  },
  ordPoNumber: {
    key: 'ordPoNumber',
    name: 'PO Number',
  },
  dataPo: {
    key: 'dataPo',
    name: 'PO Date',
  },
  ordTermGG: {
    key: 'ordTermGG',
    name: 'GG Term',
  },
  sortByInsertionDate: {
    key: 'sortByInsertionDate',
    name: 'Sort by Insertion Date',
  },
  denominazioneCliente: {
    key: 'denominazioneCliente',
    name: 'Account Name',
  },
  orderName: {
    key: 'orderName',
    name: 'Order Name',
  },
  frNumDocumento: {
    key: 'frNumDocumento',
    name: 'Document Number',
  },
  frDescrizioneCausale: {
    key: 'frDescrizioneCausale',
    name: 'Causal Description',
  },
  allProject: {
    key: 'allProject',
    name: 'Project Type',
  },
  dataFatturaDa: {
    key: 'dataFatturaDa',
    name: 'Invoice From',
  },
  dataFatturaA: {
    key: 'dataFatturaA',
    name: 'Invoice To',
  },
  clienteGamma: {
    key: 'clienteGamma',
    name: 'Account',
  },
  excludefattureAssociate: {
    key: 'excludefattureAssociate',
    name: 'Exclude Associated Invoices',
  },
  idAzienda: {
    key: 'idAzienda',
    name: 'Legal Entity',
  },
  descrizione: {
    key: 'descrizione',
    name: 'Description',
  },
  tipoFattura: {
    key: 'tipoFattura',
    name: 'Invoice Type',
  },
  importoMin: {
    key: 'importoMin',
    name: 'Min Amount',
  },
  importoMax: {
    key: 'importoMax',
    name: 'Max Amount',
  },
  importo: {
    key: 'importo',
    name: 'Amount',
  },
  year: {
    key: 'year',
    name: 'Year',
  },
  jsonFilter: {
    key: 'jsonFilter',
    name: 'JSON Filter',
  },
  filtroAnnualita: {
    key: 'filtroAnnualita',
    name: 'Period',
  },
  pkTipologiaBlocco: {
    key: 'pkTipologiaBlocco',
    name: 'Block Type',
  },
  dataInvioSalStart: {
    key: 'dataInvioSalStart',
    name: 'Start Date',
  },
  dateInvioSalEnd: {
    key: 'dateInvioSalEnd',
    name: 'End Date',
  },
  fkChiaveMisura: {
    key: 'fkChiaveMisura',
    name: 'Key',
  },
  dataConfronto: {
    key: 'dataConfronto',
    name: 'Comparison date',
  },
};

// "status": "Status",
//     "projectType": "Project Type",
//     "projectName": "Project Name",
//     "nomeProgetto": "Project Name",
//     "tipologia": "Typology",
//     "businessUnit": "Business Unit",
//     "deliveryUnit": "Delivery Unit",
//     "priceRange": "Price Range",
//     "dateRange": "Date Range",
//     "nomeCliente": "Client Name",
//     "idProgetto": "Project ID",
//     "businessManager": "Business Manager",
//     "projectManager": "Project Manager",
//     "flagPlaceholderPlanned": "Placeholder user"
